import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import Rebase from 're-base'

// Initialize Firebase

// Morning
const config = {
  apiKey: "AIzaSyD1lcLChsmaoySsNkemljgwrTvnX7dHJ0k",
  authDomain: "chatarang-s2morning.firebaseapp.com",
  databaseURL: "https://chatarang-s2morning.firebaseio.com",
  projectId: "chatarang-s2morning",
  storageBucket: "chatarang-s2morning.appspot.com",
  messagingSenderId: "96178319928"
}

// Afternoon
// const config = {
//   apiKey: "AIzaSyAP8rFgqidm-umF_vwVdD0Z2sa3BsudGAI",
//   authDomain: "chatarang-s2afternoon.firebaseapp.com",
//   databaseURL: "https://chatarang-s2afternoon.firebaseio.com",
//   projectId: "chatarang-s2afternoon",
//   storageBucket: "chatarang-s2afternoon.appspot.com",
//   messagingSenderId: "851967948253"
// }

const app = firebase.initializeApp(config)

export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const githubProvider = new firebase.auth.GithubAuthProvider()
export const auth = firebase.auth()

const db = app.database()
export default Rebase.createClass(db)



// WEBPACK FOOTER //
// ./src/base.js